export default {
  business_name: "",
  abn: "",
  trading_name: "",
  phone_number: "",
  email: "",
  business_type: "",
  contact_name: "",
  business_address: "",
  business_address_suburb: "",
  business_address_state: "",
  business_address_postcode: "",
  postal_address: "",
  postal_address_suburb: "",
  postal_address_state: "",
  postal_address_postcode: "",
  vehicles: []
};
